var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// - Import react components
import { db } from 'data/firestoreClient';
import moment from 'moment/moment';
import { SocialError } from 'core/domain/common';
import { Profile, UserProvider } from 'core/domain/users';
import { injectable } from 'inversify';
/**
 * Firbase user service
 *
 * @export
 * @class UserService
 * @implements {IUserService}
 */
var UserService = /** @class */ (function () {
    function UserService() {
        var _this = this;
        /**
         * Get user profile
         */
        this.getUserProfile = function (userId) {
            return new Promise(function (resolve, reject) {
                var userProfileRef = db.doc("userInfo/" + userId);
                userProfileRef.get().then(function (result) {
                    if (!result.exists) {
                        _this.getUserProviderData(userId).then(function (providerData) {
                            if (!UserProvider || !providerData.email) {
                                reject(reject(new SocialError("firestore/providerdata", 'firestore/getUserProfile : Provider data or email of provider data is empty!')));
                            }
                            var avatar = providerData.avatar, fullName = providerData.fullName, email = providerData.email;
                            var userProfile = new Profile(avatar, fullName && fullName !== '' ? fullName : email, '', '', moment().unix(), true, email, -1, '', '', '');
                            resolve(userProfile);
                            _this.updateUserProfile(userId, userProfile);
                        });
                    }
                    else {
                        resolve(result.data());
                    }
                })
                    .catch(function (error) { return reject(new SocialError(error.code, 'firestore/getUserProfile :' + error.message)); });
            });
        };
        this.getUserProfile2 = function (userName) {
            return new Promise(function (resolve, reject) {
                var userProfileRef = db.doc("UserNames/" + userName);
                userProfileRef.get().then(function (result) {
                    if (!result.exists) {
                        _this.getUserProviderData(userName).then(function (providerData) {
                            if (!UserProvider || !providerData.email) {
                                reject(reject(new SocialError("firestore/providerdata", 'firestore/getUserProfile : Provider data or email of provider data is empty!')));
                            }
                            var avatar = providerData.avatar, fullName = providerData.fullName, email = providerData.email;
                            var userProfile = new Profile(avatar, fullName && fullName !== '' ? fullName : email, '', '', moment().unix(), true, email, -1, '', '', '');
                            resolve(userProfile);
                            _this.updateUserProfile(userName, userProfile);
                        });
                    }
                    else {
                        resolve(result.data());
                    }
                })
                    .catch(function (error) { return reject(new SocialError(error.code, 'firestore/getUserProfile :' + error.message)); });
            });
        };
        /**
         * Update user profile
         */
        this.updateUserProfile = function (userId, profile) {
            return new Promise(function (resolve, reject) {
                var batch = db.batch();
                var profileRef = db.doc("userInfo/" + userId);
                batch.set(profileRef, __assign({}, profile, { id: userId, state: 'active' }));
                batch.commit().then(function () {
                    resolve();
                })
                    .catch(function (error) { return reject(new SocialError(error.code, 'firestore/updateUserProfile' + error.message)); });
            });
        };
        /**
         * Get users profile
         */
        this.getUsersProfile = function (userId, lastUserId, page, limit) {
            if (limit === void 0) { limit = 10; }
            return new Promise(function (resolve, reject) {
                var parsedData = [];
                var query = db.collection('userInfo').where('state', '==', 'active');
                if (lastUserId && lastUserId !== '') {
                    query = query.orderBy('id').orderBy('creationDate', 'desc').startAfter(lastUserId);
                }
                if (limit) {
                    query = query.limit(limit);
                }
                query.get().then(function (users) {
                    var newLastUserId = users.size > 0 ? users.docs[users.docs.length - 1].id : '';
                    users.forEach(function (result) {
                        var _a;
                        var user = result.data();
                        parsedData = parsedData.concat([
                            (_a = {},
                                _a[result.id] = __assign({}, user),
                                _a)
                        ]);
                    });
                    resolve({ users: parsedData, newLastUserId: newLastUserId });
                })
                    .catch(function (error) {
                    reject(new SocialError(error.code, error.message));
                });
            });
        };
        /**
         * Get uesr provider data
         */
        this.getUserProviderData = function (userId) {
            return new Promise(function (resolve, reject) {
                var userProviderRef = db.doc("userProviderInfo/" + userId);
                userProviderRef.get().then(function (snapshot) {
                    if (snapshot.exists) {
                        var userProvider = snapshot.data() || {};
                        resolve(userProvider);
                    }
                    else {
                        throw new SocialError("firestore/getUserProviderData/notExist ", "document of userProviderRef is not exist ");
                    }
                })
                    .catch(function (error) {
                    reject(new SocialError(error.code, 'firestore/getUserProviderData ' + error.message));
                });
            });
        };
    }
    UserService = __decorate([
        injectable()
    ], UserService);
    return UserService;
}());
export { UserService };



//////////////////
// WEBPACK FOOTER
// ./src/data/firestoreClient/services/users/UserService.ts
// module id = 310
// module chunks = 50